import React, { useState, useEffect } from 'react';
import App from './App';
import SessionExpiredModal from './components/general/SessionExpiredModal';
import sessionManager from './utils/sessionManager';

function AppWrapper() {
    const [showSessionExpired, setShowSessionExpired] = useState(false);

    useEffect(() => {
        // Registrar listener para sesión expirada
        sessionManager.onSessionExpired(() => {
            setShowSessionExpired(true);
        });

        // Cleanup al desmontar
        return () => {
            sessionManager.clearListeners();
        };
    }, []);

    const handleCloseSessionModal = () => {
        // Limpiar localStorage
        localStorage.removeItem('userdata');
        
        // Cerrar modal
        setShowSessionExpired(false);
        
        // Redirigir al login
        window.location.href = '/#/';
    };

    return (
        <>
            <App />
            <SessionExpiredModal 
                show={showSessionExpired} 
                onClose={handleCloseSessionModal} 
            />
        </>
    );
}

export default AppWrapper;
